const CHIPS = [
  { icon: "↓", text: "Reduce manual ticket tracking" },
  { icon: "↑", text: "Improve dispatch visibility" },
  { icon: "✓", text: "Standardize field closeouts" },
  { icon: "⚡", text: "Automate supervisor reporting" },
  { icon: "◉", text: "Centralize ticket evidence" },
  { icon: "◆", text: "Real-time operational intelligence" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="py-10 border-y border-white/5 bg-[#0a0a0a]/40 backdrop-blur-sm">
      <div className="container-x">
        <div className="flex flex-wrap items-center justify-center gap-3">
          {CHIPS.map((c) => (
            <div
              key={c.text}
              className="inline-flex items-center gap-2 rounded-full bg-[#171717] border-l-[3px] border-l-[#FB923C] border border-white/5 px-4 py-2 text-sm text-white"
            >
              <span className="text-[#F97316] font-mono">{c.icon}</span>
              <span className="text-[#94A3B8]">{c.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
